import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { htmlFormat, htmlLink, url } from "../../utils";
import Icon from "../Icon";
import Heading from "../Heading";
import CONFIGURATION from "../../configuration";
import { withUser } from "../../wrappers";
import { userShape } from "../../shapes";

type Props = {
  nodeId?: number;
  user: userShape;
};

export function AllObjectsNoAssetsFoundClue({ nodeId, user }: Props) {
  const intl = useIntl();

  return (
    <div id="no-assets-found" className="no-assets-found-clue">
      <Icon name="icon3-eh-products" />
      <Heading
        title={intl.formatMessage({ id: "assets.no_assets_found" })}
        level={2}
      />
      {!user.demoDataActive && (
        <p>
          <FormattedMessage
            id="asset.nothing_found.all_objects.message.demo_data"
            values={{
              ...htmlFormat,
              // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
              a: htmlLink({
                href: CONFIGURATION.HELP_URL_DEMODATA,
                target: "_blank",
              }),
            }}
          />
        </p>
      )}
      <p>
        <FormattedMessage id="asset.nothing_found.all_objects.message.auto_registration" />
      </p>
      <div className="no-assets-found-links">
        <Link
          className="btn btn-primary"
          to={url(nodeId ? `/nodes/${nodeId}/assets/create` : "/assets/create")}
        >
          <FormattedMessage id="button.create_asset" />
        </Link>
        <Link className="btn" to={url("/subscription")}>
          <FormattedMessage id="auto_registration.label.is_inactive" />
        </Link>
      </div>
    </div>
  );
}

export default withUser(AllObjectsNoAssetsFoundClue);
